import {gsap, ScrollTrigger} from "@gsap";
/**
 * Layout: Home - Overzicht
 * Slug: home_overview
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.home_overview-layout');

	layouts.forEach((layout) => {
		const blocks = layout.querySelectorAll(".block");

		gsap.from(blocks, {
			stagger: 0.2,
			duration: 0.3,
			y: -20,
			autoAlpha: 0,
			scrollTrigger: {
				trigger: layout,
				start: "top bottom-=5%",
				end: "bottom center+=10%",
				markers: false
			}
		})
	});
});
